import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
});

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('hcai_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const alreadyOnLogin = window.location.pathname.startsWith('/login');
    if (err.response?.status === 401 && !alreadyOnLogin) {
      sessionStorage.removeItem('hcai_token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
